export function checkStorageValue (value) {
  return ['true', 'false'].indexOf(value) >= 0 ? JSON.parse(value) : value;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/tiny-slider/src/helpers/checkStorageValue.js
// module id = 68
// module chunks = 0